module.exports = __webpack_public_path__ + "static/media/pkm-niedz3.f50a4cfb.jpg";